module.exports = __webpack_public_path__ + "img/web_question_tip_bg3_1.76322ea9.png";